<template>
  <div class="meau_wrap">
    <!--background-color="#fff"-->
    <el-menu
      class="menu whd-menu"
      @select="selectmenu"
      unique-opened
      text-color="#333"
      active-text-color="#29A7F4"
      :default-active="activeIndex"
    >
      <template v-for="(item, index) in proMenudata">
        <el-submenu
          v-if="item.children && item.children.length > 0"
          :index="item.url"
          :key="index"
        >
          <template slot="title">
            <i class="iconfontnew2" :class="item.icon"></i>
            <span>{{ item.menuName }}</span>
          </template>
          <el-menu-item
            v-for="(subitem, sindex) in item.children"
            :index="subitem.url"
            :key="sindex"
            >{{ subitem.menuName }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :index="item.url" :key="index">
          <i class="iconfontnew2" :class="item.icon"></i>
          <span slot="title">{{ item.menuName }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>
<script>
import menulist from "./menu.js";
import api from "@/api.js";

export default {
  name: "menuview",
  props: ["proMenudata"],
  data() {
    return {
      activeIndex: "/",
      menudata: [],
    };
  },
  watch: {
    proMenudata: {
      immediate: true,
      handler(val) {
        if (
          this.proMenudata[this.proMenudata.length - 1].menuName === "企业相册"
        ) {
          this.proMenudata = [
            ...this.proMenudata,
            {
              menuName: "相册分类",
              icon: "icon-xiangce",
              url: "/home/analytics/classify",
            },
          ];
        }

        console.log("watch======", this.proMenudata);
        console.log("watch======", menulist);
      },
    },
  },

  methods: {
    selectmenu(index) {
      this.$router.push({ path: index });
    },
  },
};
</script>
